<template>
<div id="team">
  <el-row :gutter="20">
    <el-col :span="6">
      <div class="img">
        <el-image :src="headerImg"></el-image>
        <div class="info">团队带头人 眭海刚</div>
      </div>
      <el-menu
          :default-active="activeIndex"
          :router="true"
      >
        <el-menu-item
            @click="saveNavState('/team/introduction')"
            index="/team/introduction"
        >
          <i class="el-icon-reading"></i>
          <span slot="title">团队介绍</span>
        </el-menu-item>
<!--        <el-menu-item-->
<!--            @click="saveNavState('/team/joinus')"-->
<!--            index="/team/joinus"-->
<!--        >-->
<!--          <i class="el-icon-trophy"></i>-->
<!--          <span slot="title">加入我们</span>-->
<!--        </el-menu-item>-->
        <el-menu-item
            @click="saveNavState('/team/conactus')"
            index="/team/conactus"
        >
          <i class="el-icon-camera"></i>
          <span slot="title">联系我们</span>
        </el-menu-item>
      </el-menu>
    </el-col>
    <el-col :span="18">
      <div class="rightContent">
        <router-view></router-view>
      </div>
    </el-col>
  </el-row>
</div>
</template>

<script>
export default {
name: "Team",
  data(){
  return {
    activeIndex: "/team/introduction",
    headerImg: require("../assets/img/people/shg1.jpg"),
  }
  },
  created() {
    var activeIndex = this.$route.query.path
    this.activeIndex = window.sessionStorage.getItem("teamAtivePath");
    console.log(activeIndex)
    if (activeIndex !== undefined ){
      this.saveNavState(activeIndex)
    } else if (this.activeIndex!==null){
      this.saveNavState(this.activeIndex)
    } else {
      this.saveNavState("/team/introduction")
    }
  },
  watch: {
    $route(route) {
      // 对路由变化作出响应...
      console.log(route.path)
    }
  },
  mounted() {
  },
  methods: {
    saveNavState(activePath) {
      window.sessionStorage.setItem("teamAtivePath", activePath);
      this.activeIndex = activePath;
      this.$router.push({path:activePath, query: {isShow:true}})
    }
  }
}
</script>

<style lang="less" scoped>
#team {
  .el-row {
    .el-col {
      .el-menu {
        border-right: none;
        box-shadow: 0px 0px 1px #4f4f4f;
      }
      .img {
        margin: 10px 0;
        .el-image{
          border-radius: 2px;
          box-shadow: 0px 0px 1px #4f4f4f;
        }
        .info{
          color: white;
          text-align: center;
          height: 30px;
          line-height: 30px;
          background-color: #076498;
        }
      }
      .rightContent{
        margin: 10px 0;
      }
    }
  }
}
</style>
